import { Component } from '@angular/core';
import { SettingsSideMenu } from '../settings-side-menu/settings-side-menu';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-settings-base',
  imports: [SettingsSideMenu, RouterOutlet],
  templateUrl: './settings-base.html',
  styleUrl: './settings-base.scss',
})
export class SettingsBase {}
